<div>
    <app-title title="Basic Sample"></app-title>
    <div [id]="gridId" [style]="gridStyle" style="padding:0 20px; box-sizing: border-box;"></div>
    <div style="padding: 0 20px; box-sizing: border-box;">
        <br>
<!--

        <select  [(ngModel)]="sSelData" style="border-radius:3px;padding:0.2em 1em;margin-top:15px">
            <option *ngFor="let item of list" [value]="item.value">{{ item.text }}</option>
        </select>
        <input type="text" [(ngModel)]="gridId">
        <img [src]="sImgSrc">
-->
    
        <div class="ff-detail-area">
            <div class="ff-img-area">
                <span class="ff-de-tit">SKETCH</span>
                <div class="ff-img">
                    <img  [src]="sImgSrc" alt="mlb"/>
                </div>
            </div>
            <div class="ff-con-area">
                <span class="ff-de-tit2">FIX</span>
                <div>
                    <div class="ff-row">
                        <div class="label"><label>브랜드</label></div>
                        <div><input [value]="sBrand" class="ff-input" disabled></div>
                        <div class="label"><label>연도</label></div>
                        <div><input [value]="sYear" class="ff-input" disabled></div>
                        <div class="label"><label>시즌</label></div>
                        <div>
                            <select class="ff-select">
                                <option>Spring</option>
                                <option></option>
                            </select>
                        </div>
                        <div class="label"><label>PO/결재</label></div>
                        <div><input value="확정" class="ff-input" disabled></div>
                        <div><input value="완료" class="ff-input" disabled></div>
                    </div>
                    <div class="ff-row">
                        <div><label>STYLE_NO</label></div>
                        <div><input [value]="sStyleNo" class="ff-input" ></div>
                        <div><label>성별</label></div>
                        <div>
                            <select   class="ff-select"[(ngModel)]="sSex">
                                <option *ngFor="let item of listSex" [value]="item.value">{{ item.label }}</option>
                            </select>
                        </div>

                        <div><label>차수</label></div>
                        <div><input value="1" class="ff-input" ></div>
                        <div><label>FAMILY품번</label></div>
                        <div>
                            <select class="ff-select">
                                <option>엠엘비</option>
                                <option></option>
                            </select>
                        </div>

                        <div><input></div>
                    </div>
                    <div class="ff-row">
                        <div><label>대구분</label></div>
                        <div>
                            <select   class="ff-select" [(ngModel)]="sDaeGubun">
                                <option *ngFor="let item of listDaeGubun" [value]="item.value">{{ item.label }}</option>
                            </select>
                        </div>
                        <div><label>복종그룹</label></div>
                        <div>
                            <select class="ff-select">
                                <option>다이마루</option>
                            </select>
                        </div>
                        <div><label>복종</label></div>
                        <div>
                            <select class="ff-select">
                                <option>맨투맨(MT)</option>
                                <option></option>
                            </select>
                        </div>
                        <div><label>상하의</label></div>
                        <div>
                            <select class="ff-select">
                                <option>상의</option>
                                <option></option>
                            </select>
                        </div>
                        <div>&nbsp;</div>
                    </div>
                    <div class="ff-row">
                        <div><label>요청납기</label></div>
                        <div>
                            <input [value]="sReqDueDate"  class="ff-input" disabled>
                        </div>
                        <div><label>판매국가</label></div>
                        <div><input [value]="sSaleCountry" class="ff-input" ></div>
                        <div><label>가판가</label></div>
                        <div><input value="85,000" class="ff-input" ></div>
                        <div><label>SET 코드1/2</label></div>
                        <div><input class="ff-input" ></div>
                        <div><input class="ff-input" ></div>
                    </div>
                    <div class="ff-row">
                        <div><label>&nbsp;</label></div>
                        <div>
                            <input [value]="sReqDueDate" disabled class="ff-input" >
                        </div>
                        <div><label>운영시즌</label></div>
                        <div>
                            <select  class="ff-select" [(ngModel)]="sSeason">
                                <option *ngFor="let item of listSeason" [value]="item.value">{{ item.label }}</option>
                            </select>
                        </div>
                        <div><label>&nbsp;</label></div>
                        <div style="width:173px;"v>&nbsp;</div>
                        <div><label>판매국 고객</label></div>
                        <div>
                            <select class="ff-select">
                                <option>공통</option>
                                <option></option>
                            </select>
                        </div>
                        <div>&nbsp;</div>
                    </div>
                    <div class="ff-row">
                        <div><label>기획구분</label></div>
                        <div><input [value]="sGiGubun" class="ff-input" ></div>
                        <div><label>생산처</label></div>
                        <div><input [value]="sManufacture" class="ff-input" ></div>
                        <div><label></label></div>
                        <div style="width:173px;"v>&nbsp;</div>
                        <div><label>CANCEL구분</label></div>
                        <div><input  class="ff-input" disabled></div>
                        <div>&nbsp;</div>
                    </div>
                </div>
                <div>
                    <div class="ff-row">
                        <div><label>합의납기</label></div>
                        <div><input [value]="sDueDate" class="ff-input" ></div>
                        <div><label>업체PO승인</label></div>
                        <div><input value="Y"  class="ff-input" disabled></div>
                        <div><label>합의납기확정</label></div>
                        <div><input value="확정"  class="ff-input" disabled></div>
                        <div><label>PDM_TYPE</label></div>
                        <div>
                            <select class="ff-select" disabled>
                                <option>의류</option>
                                <option></option>
                            </select>
                        </div>
                        <div>&nbsp;</div>
                    </div>
                </div>
            </div>

    </div>

</div>